"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.New = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var New = function (_a) {
    var description = _a.description, label = _a.label, to = _a.to, icon = _a.icon;
    return react_1.default.createElement("div", { className: "storybook-forms-new" + (to ? '-with-button' : '') },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, description),
        to && react_1.default.createElement(storybook_1.Buttons.Link, { type: 'primary', icon: icon, to: to }, label));
};
exports.New = New;
exports.New.propTypes = {
    /**
     * The Description of New
     */
    description: prop_types_1.default.string,
    /**
     * The Label of the Button
     */
    label: prop_types_1.default.string,
    /**
     * Where does the button lead to
     */
    to: prop_types_1.default.string
};
